import * as yup from 'yup'
import { DEPENDENT_FIELDS_MAP, FEATURES_MAP } from './constants'
import { FixMeLater } from '../../../types'

export const FeaturesSchema = yup.object().shape({
	...Object.keys(FEATURES_MAP).reduce(
		(acc, key) => {
			acc[key] = yup.object().shape({
				value: yup.boolean().nullable(),
			})
			return acc
		},
		{} as Record<string, yup.ObjectSchema<{ value?: boolean | null }>>
	),
	...Object.keys(DEPENDENT_FIELDS_MAP).reduce(
		(acc, key) => {
			acc[key] = yup.object().shape({
				value: yup.mixed().nullable(),
			})
			return acc
		},
		{} as Record<
			string,
			yup.ObjectSchema<{ value?: FixMeLater | null }>
		>
	),
})

export default FeaturesSchema
